export const website = {
  firstStep: {
    title: "لنبدأ! ما القالب الذي تريد استخدامه؟",
    subtitle:
      "هل أنت مستعد لإنشاء موقع رائع؟ لنبدأ بالقوالب، ثم ننتقل إلى الألوان.",
  },
  secondStep: {
    title: "ما مجموعة الألوان التي تناسب علامتك التجارية أكثر؟",
    subtitle: "خصّص قالبك بلمسة من الألوان",
  },
  thirdStep: {
    title: "هل لديك صور جيدة لمكان إقامتك؟",
    titleLine2: "حمّلها!",
    subtitle: "حمّل أفضل صورة لمكان إقامتك لعرضها في الصفحة الرئيسية",
  },
  fourthStep: {
    title: "رائع. ما رأيك في اختيار اسم لنشاطك التجاري؟",
    subtitle:
      "يعزز اسم الشركة وشعارها التعرّف على العلامة التجارية ويقوّي صورتها.",
  },
  fifthStep: {
    title: "هل لديك شعار لعلامتك التجارية؟",
    subtitle:
      "للحصول على أفضل النتائج، استخدم تصميمًا متجهيًا أو صورة PNG بخلفية شفافة. النسب المثالية هي 2:1 أو 1:1 (صورة مربعة). ويجب أن يكون الحجم 400 بكسل × 192 بكسل (بحد أدنى للارتفاع 60 بكسل). إذا لم يكن لديك شعار بعد، فسنستخدم اسم نشاطك التجاري كعلامة تجارية.",
  },
  livingstone: {
    navMain: "القائمة الرئيسية",
    navProperty: "العقار",
    navMap: "الخريطة",
    navGallery: "المعرض",
    navRates: "الأسعار",
    navAvailability: "التوفّر",
    navReviews: "التقييمات",
    bookNow: "احجز الآن",
    checkinCheckout: "الوصول → المغادرة",
    guests: "الضيوف",
  },
  tideway: {
    navMain: "القائمة الرئيسية",
    navProperty: "العقار",
    navMap: "الخريطة",
    navGallery: "المعرض",
    navRates: "الأسعار",
    navAvailability: "التوفّر",
    navReviews: "التقييمات",
    bookNow: "احجز الآن",
    checkinCheckout: "الوصول → المغادرة",
    guests: "الضيوف",
  },
};
